module.exports = __webpack_public_path__ + "assets/img/3icon.236ab51f.png";